module.exports = __webpack_public_path__ + "static/img/4.29f0ee28.png";